const DEMO_DOMAIN_MAP: Record<string, string> = {
  parrot: "paschal",
  parakeet: "paschal",
  reindeer: "randazzo",
  hawk: "hoffmann",
  pets: "hoffmann",
  quail: "qualityplumbing",
  moose: "mistersparky",
  wolf: "wilson",
  centipede: "certus",
  pangolin: "purcor",
  raccoon: "responsible",
  ladybug: "lvpc",
  locust: "lookoutpest",
};

export function processUrlForDemo(lookup: string): string {
  const subdomain = lookup.split(".")[0];
  const mapped = DEMO_DOMAIN_MAP[subdomain];
  if (mapped) {
    return lookup.replace(subdomain, mapped);
  }
  return lookup;
}

export const CENTIPEDE_DEMO_HOST = "centipede.netic.ai";

/**
 * Returns true when the current page is the centipede demo URL.
 * Pass `host` explicitly on the server; on the client, omit and we'll
 * read `window.location.hostname`.
 */
export function isCentipedeDemo(host?: string | null): boolean {
  const h = host ?? (typeof window !== "undefined" ? window.location.hostname : null);
  return h === CENTIPEDE_DEMO_HOST;
}
